<template>
  <label class="lang-selector">
    <span class="lang-selector__label">{{ $t("language.label") }}</span>
    <select v-model="selectedLocale" class="lang-selector__select" :aria-label="$t('language.label')">
      <option v-for="locale in $i18n.availableLocales" :key="locale" :value="locale">
        {{ locale.toUpperCase() }}
      </option>
    </select>
  </label>
</template>

<script>
export default {
  name: "LangSelector",
  data() {
    return {
      selectedLocale: this.$store.getters.selectedLanguage || this.$i18n.locale,
    };
  },
  watch: {
    selectedLocale(newLocale) {
      if (newLocale === this.$store.getters.selectedLanguage) {
        return;
      }

      this.$i18n.locale = newLocale;
      this.$store.dispatch("setLanguagePreference", newLocale);
    },
    "$store.getters.selectedLanguage": {
      immediate: true,
      handler(newLocale) {
        if (newLocale && this.selectedLocale !== newLocale) {
          this.selectedLocale = newLocale;
        }
      },
    },
  },
};
</script>

<style scoped>
.lang-selector {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.lang-selector__label {
  color: white;
  font-size: 12px;
  font-weight: 500;
}

.lang-selector__select {
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 6px;
  color: white;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  min-width: 64px;
  outline: none;
  padding: 4px 8px;
}

.lang-selector__select option {
  color: black;
}

@media (max-width: 960px) {
  .lang-selector__label {
    display: none;
  }
}
</style>